import {
  Collapsible as BaseCollapsible,
  type CollapsibleContentProps,
} from "@ark-ui/react";
import clsx from "clsx";
import * as React from "react";

const Collapsible = BaseCollapsible.Root;
const CollapsibleTrigger = BaseCollapsible.Trigger;

const CollapsibleContent = React.forwardRef<
  React.ElementRef<typeof BaseCollapsible.Content>,
  CollapsibleContentProps
>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <BaseCollapsible.Content
      className={clsx("ox-reset ox-CollapsibleContent", className)}
      {...rest}
      ref={ref}
    />
  );
});

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
export type { CollapsibleContentProps };
